<template>
  <div class="choose-category-block relative pb-20 md:flex">
    <div v-if="title" class="choose-category-block-text top-0 left-0 right-0 py-3 px-4 z-10">
      <h1 class="o-heading-2 text-neutral-800 mb-3" v-html="title" />
      <p v-if="description" class="o-body text-neutral-800" v-text="description" />
    </div>
    <div class="relative">
      <OImage
        v-bind="enrichedImage"
        img-class="min-w-full object-cover pointer-events-none"
        :alt="$t('Accessibilty.AltTags.ChooseCategoryImage')"
      />
      <div class="choose-category-block-buttons-container absolute top-0 right-0 bottom-0 left-0 flex flex-col pb-12">
        <div class="flex-1" />
        <div class="choose-category-block-buttons sticky flex w-full justify-around px-4">
          <div class="flex-1 mr-3 md:text-center">
            <NewButton
              :aria-label="womenAriaLabel"
              color="white"
              tag="nuxt-link"
              :to="womenLink"
              icon-right="new-chevron-right"
              class="w-full md:w-auto"
            >
              {{ $t('ChooseCategoryPage.Women') }}
            </NewButton>
          </div>
          <div class="flex-1 md:text-right">
            <NewButton
              :aria-label="menAriaLabel"
              color="white"
              tag="nuxt-link"
              :to="menLink"
              icon-right="new-chevron-right"
              class="w-full md:w-auto"
            >
              {{ $t('ChooseCategoryPage.Men') }}
            </NewButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getImagePaths } from '@/utils/general'
import OImage from '@/components/OImage'
import NewButton from '@/components/NewButton'

export default {
  name: 'ChooseCategoryBlock',
  components: { OImage, NewButton },
  props: {
    image: {
      type: String,
      default: '/images/frontend/static/mix-campaign'
    },
    womenLink: {
      type: String,
      default: '/women'
    },
    menLink: {
      type: String,
      default: '/men'
    },
    womenAriaLabel: {
      type: String,
      default: ''
    },
    menAriaLabel: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  },
  computed: {
    enrichedImage () {
      return getImagePaths({
        path: this.image,
        s3: true
      })
    }
  }
}
</script>

<style lang="postcss" scoped>
.choose-category-block {
  @apply mx-auto;
  border-bottom-left-radius: 4rem;
  border-bottom-right-radius: 4rem;
  max-width: 119.2rem;

  &-text {
    @apply relative;
    background-color: #E2E2E2;
    margin-bottom: -11rem;
  }

  &-buttons {
    bottom: 5rem;
  }

  >>> img {
    border-bottom-left-radius: 4rem;
    border-bottom-right-radius: 4rem;
  }
}

@screen md {
  .choose-category-block {
    border-radius: 4rem;

    &-text {
      @apply m-10 p-0 absolute bg-transparent mb-0;
      max-width: 34.9rem;
    }

    &-buttons {
      @apply mx-auto left-0 right-0;
      max-width: 94rem;
    }
  }
}
</style>
